import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';

export class BigdesCompensatoryControlService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }

    async getAll(params = {}) {
        try {
            const response = await withRetry(() => this.api.getAll(params), { maxRetries: 2 });
            return {
                success: true,
                data: response.data || [],
                pagination: response.pagination || {},
                uniqueValues: response.uniqueValues || {},
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch compensatory controls');
        }
    }

    async getById(id) {
        try {
            const response = await withRetry(() => this.api.getById(id), { maxRetries: 2 });
            return { success: true, data: response.data };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch compensatory control');
        }
    }

    async create(data) {
        try {
            const response = await this.api.create(data);
            return {
                success: true,
                data: response.data,
                message: response.message,
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to create compensatory control');
        }
    }

    async update(id, data) {
        try {
            const response = await this.api.update(id, data);
            return {
                success: true,
                data: response.data,
                message: response.message,
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to update compensatory control');
        }
    }

    async delete(id) {
        try {
            const response = await this.api.delete(id);
            return {
                success: true,
                data: response.data,
                message: response.message,
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to delete compensatory control');
        }
    }

    _handleError(error, fallbackMessage) {
        if (error instanceof ApiError) return error;
        return new ApiError(fallbackMessage, error?.response?.status || 500, error?.response?.data);
    }
}
